function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import SwitchingWordsComponent from "/components/core/switching-words/switching-words-component";
import classnames from "classnames";
import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";
import { StyledSwitchingTitleComponent } from "./switching-title-component.scss";
export class SwitchingTitleComponent extends PureComponent {
    render() {
        const { title, switchingWords, activeIndex, aboveTheFold } = this.props;
        return /*#__PURE__*/ _jsxs(StyledSwitchingTitleComponent, {
            className: classnames("switching-title-component", {
                "above-the-fold": aboveTheFold
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "colorful-title-wrapper",
                    children: /*#__PURE__*/ _jsx(ColorfulTitleComponent, {
                        text: title
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "switching-words-wrapper",
                    children: /*#__PURE__*/ _jsx(SwitchingWordsComponent, _object_spread_props(_object_spread({}, switchingWords), {
                        activeIndex: activeIndex
                    }))
                })
            ]
        });
    }
}
export class SwitchingTitleMobileComponent extends PureComponent {
    render() {
        const { mobileTitle } = this.props;
        return /*#__PURE__*/ _jsx(StyledSwitchingTitleComponent, {
            className: "switching-title-component switching-title-mobile-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: "colorful-title-wrapper",
                children: /*#__PURE__*/ _jsx(ColorfulTitleComponent, {
                    text: mobileTitle
                })
            })
        });
    }
}
export default withResponsiveHOC(SwitchingTitleComponent, SwitchingTitleMobileComponent);
